module.exports = __webpack_public_path__ + "static/media/pixeled-token-selector-blue.50b547fc.svg";